import { toast } from 'react-toastify';
import { createSlice } from '@reduxjs/toolkit';
import { saveOktaConnection, saveOidcConnection } from '../utils/authStorage';
import buildAuthUserFromSSOTokens from '../../lib/auth/sso';

const initialState = {
  isAuthenticated: false,
  isConnecting: false,
  currentEnv: null,
  userpoolId: null,
  userpoolClientId: null,
  graphqlEndpoint: null,
  authType: null,
  apiKey: null,
  user: null,
  users: [],
};

/* eslint no-param-reassign: ["error", { "ignorePropertyModificationsFor": ["state"] }] */
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    CONNECTING(state) {
      state.isConnecting = true;
    },
    CONNECT_ERROR(state, action) {
      toast.error(`Error: ${action.payload.message}`);
      state.isConnecting = false;
    },
    CONNECTED_TO_COGNITO(state, action) {
      const { user, cognitoConnection } = action.payload;
      toast.success('You have been successfully authenticated!');
      state.isConnecting = false;
      state.isAuthenticated = true;
      Object.assign(state, { ...cognitoConnection, user });
    },
    CONNECTED_VIA_APIKEY(state, action) {
      const { apiConnection } = action.payload;
      toast.success('You have been successfully authenticated!');
      Object.assign(state, { isConnecting: false, isAuthenticated: true, ...apiConnection });
    },
    CONNECTED_VIA_LAMBDA(state, action) {
      const { lambdaConnection } = action.payload;
      toast.success('You have been successfully authenticated!');
      Object.assign(state, { isConnecting: false, isAuthenticated: true, ...lambdaConnection });
    },
    CONNECTED_VIA_OKTA(state, action) {
      const { oktaConnection, idToken, accessToken } = action.payload;
      const user = buildAuthUserFromSSOTokens({ idToken, accessToken });
      toast.success('You have been successfully authenticated!');
      const savedOktaConnection = saveOktaConnection(oktaConnection);
      Object.assign(state, { isConnecting: false, isAuthenticated: true, ...savedOktaConnection, user, idToken, accessToken });
    },
    CONNECTED_VIA_OIDC(state, action) {
      const { oidcConnection, idToken } = action.payload;
      const user = buildAuthUserFromSSOTokens({ idToken });
      toast.success('You have been successfully authenticated!');
      const savedOidcConnection = saveOidcConnection(oidcConnection);
      Object.assign(state, { isConnecting: false, isAuthenticated: true, ...savedOidcConnection, user, idToken });
    },
    LOGOUT(state) {
      Object.assign(state, initialState);
    },
  },
});

export const authActions = authSlice.actions;
export default authSlice.reducer;
